export class EmployeeBriefDto {
  id: number;
  firstName: string;
  lastName: string;
}
